import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../components/UI/ToastProvider';

export const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { addToast } = useToast();
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // TODO: Implementar chamada à API para recuperação de senha
      // Por enquanto, apenas simularemos o sucesso
      await new Promise(resolve => setTimeout(resolve, 1500));
      addToast('Link de recuperação enviado para seu e-mail', 'success');
      navigate('/login');
    } catch (error) {
      addToast('Erro ao enviar e-mail de recuperação', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page-container">
      <div className="login-logo-top">
        <span className="logo-box">b</span>
        <span className="logo-text">Know inDoc</span>
      </div>
      <div className="login-left">
        <h2 className="login-greeting">Recuperar Senha</h2>
        <p className="login-subtitle">Digite seu e-mail para receber as instruções de recuperação:</p>
        
        <div className="login-container">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email" className="form-label">E-mail</label>
              <input
                type="email"
                id="email"
                className="form-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="seu@email.com"
                disabled={isLoading}
                autoComplete="off"
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary w-full mt-6"
              disabled={isLoading}
            >
              {isLoading ? 'Enviando...' : 'Enviar Link de Recuperação'}
            </button>

            <div className="mt-4 text-center">
              <button
                type="button"
                className="text-blue-600 hover:underline"
                onClick={() => navigate('/login')}
                disabled={isLoading}
              >
                Voltar para o Login
              </button>
            </div>
          </form>
        </div>
      </div>
      <div className="login-right" />
    </div>
  );
}; 